import classNames from "classnames";
import "./infoText.style.scss";

interface InfoTextProps {
    text?: string;
    className?: string;
    testId?: string;
    type: 'info' | 'success' | 'danger' | 'plain' | 'alert';
    hidden?: boolean;
    small?: boolean;
    medium?: boolean;
    large?: boolean;
    bold?: boolean;
}

export const InfoText = ({text = "", ...props}: React.PropsWithChildren<InfoTextProps>) => {
    return(
        <p 
            className={classNames(
                "info-text", props.type, props.className,
                {"small": props.small, "medium": props.medium, "large": props.large, "bold": props.bold}
            )}
            hidden={props?.hidden}
        >
            {props.children} {text}
        </p>
    )
}